/* ============================================================
   ANIMAL EXPERT PRODUCTS — Main JS
   ============================================================ */

/* Runs on Shopify: cart + checkout use the store's own routes. */

/* ---- STICKY NAV ---- */
(function () {
  var header = document.getElementById('site-header');
  if (!header) return;
  function onScroll() {
    header.classList.toggle('scrolled', window.scrollY > 60);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ---- PRODUCT IMAGE GALLERY ---- */
(function () {
  document.querySelectorAll('.product-card').forEach(function (card) {
    var imgs = card.querySelectorAll('.product-img');
    var thumbs = card.querySelectorAll('.thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.dataset.target, 10);
        imgs.forEach(function (img) { img.classList.remove('product-img-active'); });
        if (imgs[idx]) imgs[idx].classList.add('product-img-active');
        thumbs.forEach(function (t) { t.classList.remove('thumb-active'); });
        thumb.classList.add('thumb-active');
      });
    });
  });
})();

/* ---- ABOUT PHOTO GALLERY ---- */
(function () {
  var mainImg = document.getElementById('about-main-img');
  var thumbs = document.querySelectorAll('.about-thumb');
  if (!mainImg || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      mainImg.style.opacity = '0';
      setTimeout(function () {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt;
        mainImg.style.opacity = '1';
      }, 200);
      thumbs.forEach(function (t) { t.classList.remove('about-thumb-active'); });
      thumb.classList.add('about-thumb-active');
    });
  });
})();

/* ---- SIZE SELECTOR ---- */
(function () {
  document.querySelectorAll('.size-selector').forEach(function (selector) {
    var group = selector.dataset.product;
    var atcBtn = document.querySelector('.btn-atc[data-size-group="' + group + '"]');
    var sizeBtns = selector.querySelectorAll('.size-btn');
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('size-btn-active'); });
        btn.classList.add('size-btn-active');
        if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variant;
      });
    });
  });
})();

/* ---- SMOOTH ANCHOR SCROLL ---- */
(function () {
  var OFFSET = 80;
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - OFFSET, behavior: 'smooth' });
    });
  });
})();

/* ---- SCROLL REVEAL ---- */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var style = document.createElement('style');
  style.textContent = '.reveal{opacity:0;transform:translateY(28px);transition:opacity .55s ease,transform .55s ease}.reveal.visible{opacity:1;transform:none}';
  document.head.appendChild(style);
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('visible'); obs.unobserve(entry.target); }
    });
  }, { threshold: 0.12 });
  ['.product-info', '.philo-card', '.about-content', '.about-image-col', '.section-header', '.email-strip-text', '.email-form'].forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { el.classList.add('reveal'); obs.observe(el); });
  });
})();

/* ---- EMAIL SIGNUP ---- */
var KLAVIYO_COMPANY_ID = 'RAYxzE';
var KLAVIYO_LIST_ID    = 'UaRujK';

function klaviyoSubscribe(email) {
  return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15'
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Welcome Popup (10% off)',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
        }
      }
    })
  });
}

function isKlaviyoSuccess(res) {
  /* 202 = accepted (new subscription), 200 = ok, 409 = already subscribed */
  return res.ok || res.status === 202 || res.status === 409;
}

function handleEmailSignup(e) {
  e.preventDefault();
  var form = e.target;
  var input = form.querySelector('.email-input');
  var btn = form.querySelector('button[type="submit"]');
  if (!input || !input.value.trim()) return;

  var email = input.value.trim();
  var originalBtnText = btn.textContent;
  btn.textContent = 'Signing up…';
  btn.disabled = true;
  input.disabled = true;

  klaviyoSubscribe(email)
    .then(function (res) {
      if (isKlaviyoSuccess(res)) {
        btn.textContent = "You're in! Check your email.";
        input.value = '';
        setTimeout(function () {
          btn.textContent = originalBtnText;
          btn.disabled = false;
          input.disabled = false;
        }, 5000);
      } else {
        btn.textContent = 'Try again';
        btn.disabled = false;
        input.disabled = false;
      }
    })
    .catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
      input.disabled = false;
    });
}

/* ============================================================
   CART — Shopify native cart (AJAX API)
   Same drawer UI as the old site, but the cart now lives in
   Shopify: real prices, persists across pages, real checkout.
   ============================================================ */
(function () {

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* --- Elements --- */
  var drawer     = document.getElementById('cart-drawer');
  var overlay    = document.getElementById('cart-overlay');
  var closeBtn   = document.getElementById('cart-close');
  var navBtn     = document.getElementById('cart-nav-btn');
  var countBadge = document.getElementById('cart-count');
  var itemsEl    = document.getElementById('cart-items');
  var footerEl   = document.getElementById('cart-footer');
  var emptyEl    = document.getElementById('cart-empty');
  var subtotalEl = document.getElementById('cart-subtotal-price');
  var checkoutBtn = document.getElementById('cart-checkout-btn');
  if (!drawer || !itemsEl) return;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --- Open / Close --- */
  function openCart() {
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (navBtn)   navBtn.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay)  overlay.addEventListener('click', closeCart);

  /* --- Shopify cart API --- */
  function api(path, body) {
    var opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }
      : { headers: { 'Accept': 'application/json' } };
    return fetch(root + path, opts).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function refresh() { return api('cart.js').then(renderCart); }

  /* --- Render cart --- */
  function renderCart(cart) {
    var totalQty = cart.item_count || 0;
    itemsEl.innerHTML = '';

    cart.items.forEach(function (item) {
      var title = item.product_title + (item.variant_title ? ' — ' + item.variant_title : '');
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var row = document.createElement('div');
      row.className = 'cart-item';
      row.innerHTML =
        (img ? '<img src="' + esc(img) + '" alt="' + esc(title) + '" class="cart-item-img" />' : '<div class="cart-item-img"></div>') +
        '<div class="cart-item-info">' +
          '<p class="cart-item-title">' + esc(title) + '</p>' +
          '<div class="cart-item-qty">' +
            '<button class="qty-btn" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '">&#8722;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button class="qty-btn" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '">&#43;</button>' +
          '</div>' +
        '</div>' +
        '<button class="cart-item-remove" data-key="' + esc(item.key) + '" data-qty="0" aria-label="Remove">&#10005;</button>';
      itemsEl.appendChild(row);
    });

    if (countBadge) {
      if (totalQty > 0) { countBadge.textContent = totalQty; countBadge.style.display = 'flex'; }
      else { countBadge.style.display = 'none'; }
    }

    /* Mirror qty for popup logic */
    window.AE_cartQty = totalQty;
    document.dispatchEvent(new CustomEvent('ae:cart-updated', { detail: { qty: totalQty } }));

    if (cart.items.length > 0) {
      emptyEl.style.display = 'none';
      footerEl.style.display = 'block';
      subtotalEl.textContent = cart.total_price > 0 ? money(cart.total_price) : 'Free';
    } else {
      emptyEl.style.display = 'block';
      footerEl.style.display = 'none';
    }

    itemsEl.querySelectorAll('[data-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        api('cart/change.js', { id: btn.dataset.key, quantity: parseInt(btn.dataset.qty, 10) })
          .then(renderCart)
          .catch(refresh);
      });
    });

    if (checkoutBtn) checkoutBtn.href = root + 'checkout';
  }

  /* --- Add to Cart buttons --- */
  document.querySelectorAll('.btn-atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;
      var label = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      api('cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
        .then(function () {
          btn.textContent = 'Added!';
          if (window.fbq) fbq('track', 'AddToCart');
          return refresh();
        })
        .then(openCart)
        .catch(function (err) {
          btn.textContent = (err && err.description) ? 'Unavailable' : 'Try again';
        })
        .then(function () {
          setTimeout(function () { btn.textContent = label.trim() || 'Add to Cart'; btn.disabled = false; }, 1500);
        });
    });
  });

  /* Initial render */
  refresh().catch(function () {});

})();

/* ============================================================
   WELCOME POPUP — custom, on-brand, submits to Klaviyo API
   Triggers 15s after load OR on exit-intent. Suppressed if
   cart has items, if dismissed this session, or already shown.
   ============================================================ */
(function () {
  var DELAY_MS        = 15000;
  var STORAGE_KEY     = 'ae_welcome_popup_state';
  var DISMISS_HOURS   = 168; /* 7 days */

  var overlay = document.getElementById('welcome-popup-overlay');
  var modal   = document.getElementById('welcome-popup');
  if (!overlay || !modal) return;

  var closeBtn  = modal.querySelector('.welcome-popup-close');
  var form      = modal.querySelector('#welcome-popup-form');
  var emailIn   = modal.querySelector('#welcome-popup-email');
  var submitBtn = modal.querySelector('#welcome-popup-submit');
  var successEl = modal.querySelector('.welcome-popup-success');
  var formEl    = modal.querySelector('.welcome-popup-body');

  var shown      = false;
  var delayTimer = null;

  function recentlyDismissed() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (!data || !data.ts) return false;
      var ageHrs = (Date.now() - data.ts) / 36e5;
      return ageHrs < DISMISS_HOURS;
    } catch (err) { return false; }
  }

  function rememberDismiss() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now() })); }
    catch (err) { /* ignore */ }
  }

  function cartHasItems() { return (window.AE_cartQty || 0) > 0; }

  function open() {
    if (shown) return;
    if (cartHasItems()) return;
    if (recentlyDismissed()) return;
    shown = true;
    cleanup();
    overlay.classList.add('open');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (emailIn) emailIn.focus(); }, 400);
  }

  function close() {
    overlay.classList.remove('open');
    modal.classList.remove('open');
    document.body.style.overflow = '';
    rememberDismiss();
  }

  function cleanup() {
    if (delayTimer) { clearTimeout(delayTimer); delayTimer = null; }
    document.removeEventListener('mouseout', onExitIntent);
  }

  function onExitIntent(e) {
    if (e.clientY <= 0) open();
  }

  /* Wire close */
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);

  /* ESC to close */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) close();
  });

  /* Form submit → Klaviyo */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailIn.value || '').trim();
      if (!email) return;

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';

      klaviyoSubscribe(email)
        .then(function (res) {
          if (isKlaviyoSuccess(res)) {
            formEl.style.display = 'none';
            successEl.style.display = 'block';
            rememberDismiss();
            setTimeout(close, 4000);
          } else {
            submitBtn.textContent = 'Try again';
            submitBtn.disabled = false;
          }
        })
        .catch(function () {
          submitBtn.textContent = 'Try again';
          submitBtn.disabled = false;
        });
    });
  }

  /* Suppress on add-to-cart click */
  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('.btn-atc');
    if (atc) { shown = true; cleanup(); }
  });

  /* Start triggers */
  if (!recentlyDismissed()) {
    delayTimer = setTimeout(open, DELAY_MS);
    document.addEventListener('mouseout', onExitIntent);
  }
})();

/* ============================================================
   SWIPE — product photo galleries
   Swipe left/right (touch, or click-and-drag with a mouse) to
   move between photos. Uses the existing thumbnail buttons, so
   the main image and the highlighted thumbnail stay in sync.
   ============================================================ */
(function () {
  document.querySelectorAll('.product-media').forEach(function (media) {
    var stage = media.querySelector('.product-images');
    var thumbs = media.querySelectorAll('.thumb');
    if (!stage || thumbs.length < 2) return;

    function current() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('thumb-active')) return i;
      return 0;
    }
    function go(delta) {
      var next = (current() + delta + thumbs.length) % thumbs.length;
      thumbs[next].click();
    }

    var startX = null, startY = null, dragging = false;
    stage.addEventListener('pointerdown', function (e) {
      startX = e.clientX; startY = e.clientY; dragging = true;
    });
    stage.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    });
    stage.addEventListener('pointercancel', function () { dragging = false; });
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* keyboard: arrow keys when the gallery has focus */
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });
  });
})();
